import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Modal, Button, Spinner } from "react-bootstrap";
import APICom from "../../../utils/helpers/APICom";
import CommonFunctions from "../../../utils/helpers/CommonFunctions";
import ConfirmationModal from "../../Controls/ConfirmationModal";

const Cluster = (props) => {
    const { AffiliateData, GlobalASCSData } = useSelector((store) => store.combinedata);
    const [showClusterAlert, setClusterAlert] = useState(false);
    const [clusterAlertObj, setClusterAlertObj] = useState({ alertTitle: '', alertMsg: '', displayFooter: true });
    const { loginData } = useSelector((store) => store.login);
    const [confirmationModalObj, setConfirmationModalObj] = useState({
        show: false, title: 'Auto Routing',
        body: 'Are you Sure you want to Pause Auto-Routing?', btnCanceText: 'No',
        btnOkText: 'Yes'
    });

    useEffect(() => {
        async function fetchData() {
            try {
                if (props.GridRowData === null || props.GridRowData.length <= 0) {
                    setClusterAlertObj({ ...clusterAlertObj, alertTitle: 'Cluster Action', alertMsg: 'No request selected to perform Action.', displayFooter: true });
                    setClusterAlert(true);
                }
                else {
                    let result = await CommonFunctions.checkAutoRouting(props.selectedAffiliates, props.selectedDate, AffiliateData);
                    if (result)
                        setConfirmationModalObj((prevState) => ({ ...prevState, show: true, title: 'Auto Routing', body: 'Are you Sure you want to Pause Auto-Routing?', btnCanceText: 'No', btnOkText: 'Yes' }));
                    else ClusteringAction();
                }
            }
            catch (err) { console.log(err); }
        }

        fetchData();

    }, []);

    async function ClusteringAction() {
        const selectedGridData = props.GridRowData
        const pickupDateTime = selectedGridData[0].PickupDateTime;
        const affID = selectedGridData[0].iSRATSPID;
        let callBackURL = "";
        let bMessageShown = false;
        let bUnGroupedTripsFound = false;
        const SelectedRecordsForARB = [];
        const vServiceIDs = [...new Set(selectedGridData
            .map(data => data.ServiceID)
            .filter(ServiceID => ServiceID)
        )];
        const vScheduleIDs = [...new Set(selectedGridData
            .map(data => data.iScheduleID)
            .filter(iScheduleID => iScheduleID)
        )];

        if (GlobalASCSData !== null && GlobalASCSData !== undefined) {
            const jsonArray = GlobalASCSData;
            const URL = jsonArray.find(item => item.SubTitle === "AsteriskServerToClientCommAPI_URL");
            callBackURL = URL.value + '/WMRMSCommonAPI/SendMessageToWMRMS';
        }

        for (let k = 0; k < selectedGridData.length; k++) {
            if (selectedGridData[k].Route != "") {
                setClusterAlertObj({ ...clusterAlertObj, alertTitle: 'Cluster Assignment Restricted', alertMsg: 'Please select only unrouted trips!', displayFooter: true });
                setClusterAlert(true);
                bMessageShown = true;
                break;
            }
            else if (props.setIsCreateNew == false && props.isGroupAndCluster == false && selectedGridData[k].PickupPerson == "BreakTrip") {
                setClusterAlertObj({ ...clusterAlertObj, alertTitle: 'Cluster Assignment Restricted', alertMsg: 'Action not allowed for Break Trip!', displayFooter: true });
                setClusterAlert(true);
                bMessageShown = true;
                break;
            }
            else if (props.setIsCreateNew == false && props.isGroupAndCluster == false && (selectedGridData[k].PickupPerson == "SDepot" || selectedGridData[k].PickupPerson == "EDepot")) {
                setClusterAlertObj({ ...clusterAlertObj, alertTitle: 'Cluster Assignment Restricted', alertMsg: 'Action not allowed for Depot Trip!', displayFooter: true });
                setClusterAlert(true);
                bMessageShown = true;
                break;
            }
            else if (selectedGridData[k].iSRATSPID !== affID) {
                setClusterAlertObj({ ...clusterAlertObj, alertTitle: 'Cluster Assignment Restricted', alertMsg: 'Cannot cluster trips with different affiliates!', displayFooter: true });
                setClusterAlert(true);
                bMessageShown = true;
                break;
            }
            else if (props.isGroupAndCluster && selectedGridData[k].Group) {
                setClusterAlertObj({ ...clusterAlertObj, alertTitle: 'Cluster Assignment Restricted', alertMsg: 'Action not allowed for already grouped trips!', displayFooter: true });
                setClusterAlert(true);
                bMessageShown = true;
                break;
            }
            else if (selectedGridData[k].CreatedBy === "(ExternalDispatch)") {
                setClusterAlertObj({ ...clusterAlertObj, alertTitle: 'Cluster Assignment Restricted', alertMsg: 'This is a broker trip, cluster assignement is not allowed!', displayFooter: true });
                setClusterAlert(true);
                bMessageShown = true;
                break;
            }
            else if (selectedGridData[k].TripRequestStatus.toLowerCase().indexOf("cancel") > -1 || selectedGridData[k].TripRequestStatus.toLowerCase().indexOf("show") > -1
                || selectedGridData[k].ServiceStatus.toLowerCase().indexOf("cancel") > -1 || selectedGridData[k].ServiceStatus.toLowerCase().indexOf("show") > -1) {
                setClusterAlertObj({ ...clusterAlertObj, alertTitle: 'Cluster Assignment Restricted', alertMsg: 'Canceled\NoShow trips can not be cluster.', displayFooter: true });
                setClusterAlert(true);
                bMessageShown = true;
                break;
            }
            // else if (selectedGridData[k].iMVOriginalATSPID != "-1" && selectedGridData[k].iMVRouteATSPID != "-1") {
            //     if (selectedGridData[k].iMVOriginalATSPID != selectedGridData[k].iMVRouteATSPID) {
            //         setClusterAlertObj({ ...clusterAlertObj, alertTitle: 'Cluster Assignment Restricted', alertMsg: 'This is a transfered route, group assignement is not allowed!' , displayFooter:true});
            //         setClusterAlert(true);
            //         bMessageShown = true;
            //         break
            //     }
            // }
            else {
                if (selectedGridData[k].Route === "")
                    bUnGroupedTripsFound = true;
                SelectedRecordsForARB.push({
                    AffiliateID: selectedGridData[k].iSRATSPID,
                    ServiceID: selectedGridData[k].ServiceID,
                    ScheduleID: String(selectedGridData[k].bIsSchedule).toUpperCase() === "TRUE" ? selectedGridData[k].iScheduleID : "-1",
                    Confirmation: selectedGridData[k].ConfirmationNo,
                    PickupDateTime: selectedGridData[k].PickupDateTime,
                    ManifestNumber: selectedGridData[k].vManifestNumber,
                    SchDetailID: selectedGridData[k].SchDetailID,
                    Group: selectedGridData[k].Group,
                });
            }
        }

        if (props.isGroupAndCluster && !bMessageShown && SelectedRecordsForARB.length > 0) {
            let distinctRefIds = [...new Set(selectedGridData.map(data => data.ConfirmationNo).filter(ConfirmationNo => ConfirmationNo))];
            let vRefIDs = distinctRefIds.join(', ');

            let Param = {
                "bGroup": true,
                "bNewGroup": true,
                "vGroupName": "",
                "bOptionalUserGroup": false,
                "vRefIDs": vRefIDs,
                "pickupDateTime": pickupDateTime
            };
            try {
                setClusterAlertObj({ ...clusterAlertObj, alertTitle: 'Initializing Grouping Process', alertMsg: 'Please Wait...', displayFooter: false });
                setClusterAlert(true);
                props.disbaleButton(true);

                let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Grouping/MakeNewGroup", "post", { "Content-Type": "application/json" }, Param, null);
                let result = response.data;
                if (result && result.length > 0 && result[0].vGroupName !== '' && result[0].vGroupName !== 'ungroup' && result[0].vGroupName !== 'ALREADY EXISTS') {
                    // Grouping is successful. Update the records with the new group name.
                    SelectedRecordsForARB.forEach(record => {
                        record.Group = result[0].vGroupName;
                    });
                } else {
                    setClusterAlertObj({ ...clusterAlertObj, alertTitle: 'Grouping Failed', alertMsg: 'Failed to group selected trips.', displayFooter: true });
                    setClusterAlert(true);
                    props.disbaleButton(false);
                    return;
                }
            } catch (err) {
                console.log(err);
                setClusterAlertObj({ ...clusterAlertObj, alertTitle: 'Grouping Failed', alertMsg: 'Failed to group selected trips.', displayFooter: true });
                setClusterAlert(true);
                props.disbaleButton(false);
                return;
            }
        }

        if (bUnGroupedTripsFound && props.showClusterActionCreate && SelectedRecordsForARB.length > 0 && !bMessageShown) {
            if (props.manifestNumber === "" || props.isGroupAndCluster)
                NewCluster(vServiceIDs.join(','), vScheduleIDs.join(','), pickupDateTime, affID, "1", "", true, callBackURL, SelectedRecordsForARB);
            else
                NewCluster(vServiceIDs.join(','), vScheduleIDs.join(','), pickupDateTime, affID, "1", props.manifestNumber, false, callBackURL, SelectedRecordsForARB);
        }
        // else if (!bUnGroupedTripsFound && !bMessageShown) {
        //     setClusterAlertObj({ ...clusterAlertObj, alertTitle: 'Cluster Assignment Restricted', alertMsg: 'Please select atleast one un-grouped trip for this action!' , displayFooter:true});
        //     setClusterAlert(true);
        // }
    }

    const handleConfirmationModalClose = () => {
        setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
    }
    const NewCluster = async (serIDs, schIDs, reqDate, affID, type, manifest, mandatoryGrouping, cbURL, arrObj) => {
        props.disbaleButton(true);
        let Param = {
            "assigned_driver_id": 0,
            "assigned_vehicle_id": 0,
            "service_ids_str": serIDs,
            "schedule_ids_str": schIDs,
            "mini_cluster_type": type,
            "req_date_str": reqDate,
            "manifest_number": manifest,
            "affiliate_id": affID,
            "requested_page_name": "ClusteringActions",
            "mandatory_grouping": mandatoryGrouping,
            "user_id": loginData.iUserID,
            "app_id": 26,
            "selected_records_for_cb": JSON.stringify(arrObj),
            "call_back_url": cbURL,
            "SelectedRouteSettingID": String(props.SelectedRouteSettingID)
        }
        setClusterAlertObj({ ...clusterAlertObj, alertTitle: 'Initializing Clustering Process', alertMsg: 'Please Wait...', displayFooter: false });
        setClusterAlert(true);
        props.disbaleButton(true);
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Clustering/MakeCluster", "post", { "Content-Type": "application/json" }, Param, null);
        let result = response.data;
        if (result.run_id > 0) {
            setClusterAlertObj({ ...clusterAlertObj, alertTitle: 'Clustering Started', alertMsg: 'Clustering is being performed...', displayFooter: false });
            setClusterAlert(true);
            props.disbaleButton(true);
        }
        else if (result.error_message !== null && result.error_message !== "") {
            setClusterAlertObj({ ...clusterAlertObj, alertTitle: 'Cluster', alertMsg: result.error_message, displayFooter: true });
            setClusterAlert(true);
            props.disbaleButton(false);
        }
        else {
            setClusterAlertObj({ ...clusterAlertObj, alertTitle: 'Cluster', alertMsg: 'Something went wrong !!!', displayFooter: true });
            setClusterAlert(true);
            props.disbaleButton(false);
        }

    }

    const handleClusterAlertClose = () => {
        setClusterAlert(false);
        UnMountClusterComponent();
    }

    const UnMountClusterComponent = () => {
        if (props.showClusterActionCreate) {
            props.setClsuterActionCreate(false);
        }
    }

    const handleConfirmationModalOk = () => {
        CommonFunctions.SaveRBSStatus(1, props.selectedDate, props.selectedAffiliates, loginData.iUserID);
        setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
        props.setClsuterActionCreate(false);
        ClusteringAction();

    }

    const handleConfirmationModalCancel = () => {
        setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
        props.setClsuterActionCreate(false);
    }

    return (
        <>
            {showClusterAlert ? <Modal centered keyboard={false} backdrop="static" animation={true} show={showClusterAlert} onHide={handleClusterAlertClose} >
                <Modal.Header>
                    <Modal.Title>{clusterAlertObj.alertTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body><b>{clusterAlertObj.alertMsg}</b></Modal.Body>
                {clusterAlertObj.displayFooter ?
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClusterAlertClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                    : ""}
            </Modal> : ""}
            <ConfirmationModal show={confirmationModalObj.show} Title={confirmationModalObj.title} Body={confirmationModalObj.body}
                onOk={handleConfirmationModalOk} onCancel={handleConfirmationModalCancel} onClose={handleConfirmationModalClose} btnCanceText={confirmationModalObj.btnCanceText}
                btnOkText={confirmationModalObj.btnOkText} ShowCancelButton="true" />
        </>
    );

};

export default Cluster;